import axios from "./index";

const consultationCorrectionsApi = {
  acceptSuggestion({ suggestionId }) {
    return axios
      .post(`/api/v1/consultation_correction_suggestions/${suggestionId}/accept`)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Failed to accept consultation correction suggestion", error);
        throw error;
      });
  },
  ignoreSuggestion({ suggestionId }) {
    return axios
      .post(`/api/v1/consultation_correction_suggestions/${suggestionId}/ignore`)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Failed to ignore consultation correction suggestion", error);
        throw error;
      });
  },
  fetchCorrectionRequests({ consultationId }) {
    if (!consultationId) return Promise.resolve(undefined);

    return axios
      .get("/api/v1/consultation_correction_requests", {
        params: { anytime_consultation_id: consultationId },
      })
      .then((response) => {
        const data = response?.data;
        if (!data) return undefined;

        return data;
      });
  },
  requestCorrections({ consultationId, correctionTypes, answer }) {
    if (!consultationId) return Promise.reject(new Error("consultationId is required"));

    return axios.post("/api/v1/consultation_correction_requests", {
      anytime_consultation_id: consultationId,
      correction_types: correctionTypes,
      answer,
    });
  }
};

export default consultationCorrectionsApi;
